import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchIconsData = createAsyncThunk(
    'settings/fetchIconsData',
    async (type = "icon") => {
        try {
            const response = await api.get('/settings', {
                params: {
                    "type": "icon",
                }
            });
            return response.data.data;
        } catch (error) {
            return error;
        }

    }
)

export const settingIconSlice = createSlice({
    name: "setting",
    initialState: {
        loading: false,
        error: null,
        settings: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchIconsData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchIconsData.fulfilled, (state, action) => {
                state.loading = false;
                state.settings = action.payload;
            })
            .addCase(fetchIconsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export default settingIconSlice.reducer;
